import { LngLatBounds } from 'mapbox-gl';
import { AvatarType, NestedSearch, TODO, CountResult } from '@habity/types';
import { createWithEqualityFn } from 'zustand/traditional';
import { AutocompleteItem } from '@habity/types/autocomplete';
import type { Feature, Polygon, GeoJsonProperties } from 'geojson';

export interface HomesProps {
  filters: Partial<NestedSearch> | null;
  count: CountResult;
  locations: AutocompleteItem[];
  drawnAreas: Feature<Polygon, GeoJsonProperties>[];
  claimedHomesCount: number | null;
  claimedHomesAvatars: AvatarType[] | null;
  completionResult?: TODO | null;
  mapBounds?: LngLatBounds | null;
  claimInputValue?: TODO | null;
}

export interface HomesState extends HomesProps {
  setFilters: (filters: Partial<NestedSearch> | null) => void;
  setCount: (count: CountResult) => void;
  setLocations: (locations: AutocompleteItem[]) => void;
  setDrawnAreas: (areas: Feature<Polygon, GeoJsonProperties>[]) => void;
  setClaimedHomesCount: (claimedHomesCount: number | null) => void;
  setClaimedHomesAvatars: (claimedHomesAvatars: AvatarType[] | null) => void;
  setCompletionResult: (completionResult: TODO | null) => void;
  setMapBounds: (mapBounds: LngLatBounds | null) => void;
  setClaimInputValue: (claimInputValue: TODO | null) => void;
}

const DEFAULT_PROPS: HomesProps = {
  filters: null,
  count: {
    homes: 0,
    speculators: 0,
    speculatorsUnique: 0,
    speculatorsViewing: 0,
    speculatorsBidding: 0,
    brokers: 0,
    areas: 0,
    municipalities: 0,
    projects: 0,
    places: 0
  },
  locations: [],
  drawnAreas: [],
  claimedHomesCount: null,
  claimedHomesAvatars: null,
  completionResult: null,
  mapBounds: null,
  claimInputValue: null,
};

export const useHomesStore = createWithEqualityFn<HomesState>()((set) => ({
  ...DEFAULT_PROPS,
  setFilters: (filters) => {
    set({ filters });
  },
  setCount: (count) => {
    set({ count });
  },
  setLocations: (locations) => {
    set({ locations });
  },
  setDrawnAreas: (drawnAreas) => {
    set({ drawnAreas });
  },
  setClaimedHomesCount: (claimedHomesCount) => {
    set({ claimedHomesCount });
  },
  setClaimedHomesAvatars: (claimedHomesAvatars) => {
    set({ claimedHomesAvatars });
  },
  setCompletionResult: (completionResult) => {
    set({ completionResult });
  },
  setMapBounds: (mapBounds) => {
    set({ mapBounds });
  },
  setClaimInputValue: (claimInputValue) => {
    set({ claimInputValue });
  },
}));
